import React from "react";
import { getLastInfo } from "./computedTexts"

const transTemplate = cardStyleFields => {
    const res = [];
    cardStyleFields.map((item) => {
        res.push({
            i: item.cardcontentid + "",
            x: item.xcoordinate,
            y: item.ycoordinate,
            w: item.wide,
            h: item.high,
            beforecontent: item.beforecontent || "",
            aftercontent: item.aftercontent || "",
            fontSize: item.wordsize,
            bold: item.bold === 1,
            align: parseInt(item.fontjustification),
            name: item.name,
            showInfo: (item.cardcontentid == "1050" ? (window.__kd_cdnPath__) : "") + (item.sampledates ? item.sampledates[0] : item.sampledate)
        });
    });

    return res
}

export const makeModelList = (templateMap, defaultColor) => {
    const modelList = []
    for (const key in templateMap) {
        if (Object.hasOwnProperty.call(templateMap, key)) {
            const template = templateMap[key]
            modelList.push({
                id: key,
                model: transTemplate(template.cardStyleFields),
                backgroundcolor: template.backgroundcolor ?? defaultColor.backgroundcolor,
                bordercolor: template.bordercolor ?? defaultColor.bordercolor,
                topbordercolor: template.topbordercolor ?? defaultColor.topbordercolor,
            });
        }
    }
    return modelList
}

export const computeCardHeight = fieldsList => {
    let height = 0;

    fieldsList.forEach(fields => {
        height = Math.max(height, fields.y + fields.h)
    })

    return height + "px"

}

export const makeCard = modelItem => {

    const justifyContent = modelItem.align === 1 ? "start" : modelItem.align === 2 ? "center" : "end"

    const style = {
        width: modelItem.w + "px",
        height: modelItem.h + "px",
        top: modelItem.y + "px",
        left: modelItem.x + "px",
    }

    if (isImg(modelItem.i)) {
        const size = Math.min(modelItem.w, modelItem.h) - 8
        return (
            <div className="fields-item" key={modelItem.i} style={{
                ...style,
                justifyContent: "center",
                alignItem: "center"
            }}>
                <img style={{ width: size + "px", height: size + "px" }} src={"./" + modelItem.showInfo} alt="img" />
            </div>
        )
    } else {
        return (
            <div className="fields-item" key={modelItem.i} style={{
                ...style,
                width: (modelItem.w - 8) + "px",
                padding: "0 4px",
                justifyContent
            }}>
                <div className="text-box" style={{
                    fontWeight: modelItem.bold ? 600 : 100,
                    fontSize: modelItem.fontSize + "px",
                }}>
                    {lastShowInfo(modelItem)}
                </div>
            </div>
        )
    }
}

export const lastShowInfo = (item) => {
    // return item.beforecontent + "" + item.showInfo + "" + item.aftercontent
    return getLastInfo(
        item.beforecontent + item.showInfo + item.aftercontent,
        parseInt(item.fontSize),
        parseInt(item.w) - 8,
        parseInt(item.h),
        item.bold ? 600 : 100
    );
}

export const isImg = id => (id == "1050" || id == "1250")